module.exports = __webpack_public_path__ + "media/images/steps/step4-f9a25c26f9e470dc083e6af73fe877e4.svg";